import { Tag } from "antd"

export const winNotificationsColumns = [
  { title: "ID", dataIndex: ["id"], key: "id" },
  {
    title: "Optimove Template ID",
    dataIndex: ["optimoveTemplateId"],
    key: "optimoveTemplateId",
  },
  {
    title: "Name",
    dataIndex: ["name"],
    key: "name",
  },
  {
    title: "Title",
    key: "title",
    dataIndex: ["title"],
  },
  {
    title: "Body",
    key: "body",
    dataIndex: ["body"],
  },
  {
    title: "Main Image",
    dataIndex: ["mainImageUrl"],
    key: "mainImageUrl",
    render: url => url ? <img src={url} alt="main" style={{ maxWidth: "80px" }} /> : null,
  },
  {
    title: "Icon Image",
    dataIndex: ["iconImageUrl"],
    key: "iconImageUrl",
    render: url => url ? <img src={url} alt="icon" style={{ maxWidth: "80px" }} /> : null,
  },
  {
    title: "Time to Live",
    dataIndex: ["timeToLive"],
    key: "timeToLive",
    render: timeToLive => timeToLive ? <Tag>{timeToLive}</Tag> : null,
  },
  {
    title: "Buttons",
    key: "buttons",
    dataIndex: ["buttons"],
    render: buttons => {
      if (!Array.isArray(buttons)) return null

      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {buttons.map(btn => (
            <Tag key={btn.id}>
              Text: {btn.text} | URL: {btn.url}
            </Tag>
          ))}
        </div>
      )
    },
  },
]
